export const superRegionDisplayNames = {
    OTHER: {
        ar: "أخرى",
        cs: "Jiné",
        da: "Øvrigt",
        de: "Andere",
        el: "Άλλο",
        en: "Other",
        es: "Otro",
        "es-MX": "Otro",
        "es-PR": "Otro",
        fi: "Muu",
        fr: "Autre",
        "fr-CA": "Autre",
        he: "אחר",
        hr: "Drugo",
        hu: "Egyéb",
        is: "Annað",
        it: "Altro",
        ja: "その他",
        ko: "기타",
        nl: "Anders",
        no: "Annet ",
        pl: "Inne",
        pt: "Outro",
        ro: "Altele",
        sl: "Drugo",
        sv: "Övrigt",
        th: "อื่นๆ",
        tr: "Diğer",
        zh: "其他",
        "zh-HK": "其他",
        "zh-TW": "其他",
    },
    REAP: {
        ar: "منطقة آسيا والمحيط الهادئ",
        cs: "Asie/Tichomoří",
        da: "Asien Pacific",
        de: "Asien/Pazifik",
        el: "Ασία - Ειρηνικός",
        en: "Asia Pacific",
        es: "Asia-Pacífico",
        "es-MX": "Pacífico Asiático",
        "es-PR": "Asia-Pacífico",
        fi: "Aasia ja Tyynimeri",
        fr: "Asie Pacifique",
        "fr-CA": "Asie/Pacifique",
        he: "אסיה ואזור האוקיינוס השקט",
        hr: "Azija-Pacifik",
        hu: "Ázsia és a Csendes-óceáni térség",
        is: "Asía Kyrrahaf",
        it: "Asia Pacifico",
        ja: "アジア太平洋",
        ko: "아시아 태평양",
        nl: "Asia Pacific",
        no: "Asia-Pacific",
        pl: "Azja–Pacyfik",
        pt: "Ásia-Pacífico",
        ro: "Asia-Pacific",
        sl: "Azijsko-pacifiška regija",
        sv: "Asien, Stillahavsregionen",
        th: "เอเชียแปซิฟิก",
        tr: "Asya Pasifik",
        zh: "亚太地区",
        "zh-HK": "亞太區",
        "zh-TW": "亞太地區",
    },
    REAU: {
        ar: "إفريقيا",
        cs: "Afrika",
        da: "Afrika",
        de: "Afrika",
        el: "Αφρική",
        en: "Africa",
        es: "África",
        "es-MX": "África",
        "es-PR": "África",
        fi: "Afrikka",
        fr: "Afrique",
        "fr-CA": "Afrique",
        he: "אפריקה",
        hr: "Afrika",
        hu: "Afrika",
        is: "Afríka",
        it: "Africa",
        ja: "アフリカ",
        ko: "아프리카",
        nl: "Afrika",
        no: "Afrika",
        pl: "Afryka",
        pt: "África",
        ro: "Africa",
        sl: "Afrika",
        sv: "Afrika",
        th: "แอฟริกา",
        tr: "Afrika",
        zh: "非洲",
        "zh-HK": "非洲",
        "zh-TW": "非洲",
    },
    REEU: {
        ar: "أوروبا",
        cs: "Evropa",
        da: "Europa",
        de: "Europa",
        el: "Ευρώπη",
        en: "Europe",
        es: "Europa",
        "es-MX": "Europa",
        "es-PR": "Europa",
        fi: "Eurooppa",
        fr: "Europe",
        "fr-CA": "Europe",
        he: "אירופה",
        hr: "Europa",
        hu: "Európa",
        is: "Evrópa",
        it: "Europa",
        ja: "ヨーロッパ",
        ko: "유럽",
        nl: "Europa",
        no: "Europa",
        pl: "Europa",
        pt: "Europa",
        ro: "Europa",
        sl: "Evropa",
        sv: "Europa",
        th: "ยุโรป",
        tr: "Avrupa",
        zh: "欧洲",
        "zh-HK": "歐洲",
        "zh-TW": "歐洲地區",
    },
    REME: {
        ar: "الشرق الأوسط",
        cs: "Střední východ",
        da: "Mellemøsten ",
        de: "Naher Osten",
        el: "Μέση Ανατολή",
        en: "Middle-East",
        es: "Oriente Medio",
        "es-MX": "Medio Oriente",
        "es-PR": "Oriente Medio",
        fi: "Lähi-itä",
        fr: "Moyen-Orient",
        "fr-CA": "Moyen-Orient",
        he: "המזרח התיכון",
        hr: "Bliski istok",
        hu: "Közel-Kelet",
        is: "Mið-Austurlönd",
        it: "Medio Oriente",
        ja: "中東",
        ko: "중동",
        nl: "Midden-Oosten",
        no: "Midtøsten",
        pl: "Bliski Wschód",
        pt: "Médio Oriente",
        ro: "Orientul Mijlociu",
        sl: "Bližnji vzhod",
        sv: "Mellanöstern",
        th: "ตะวันออกกลาง",
        tr: "Orta Doğu",
        zh: "中东",
        "zh-HK": "中東",
        "zh-TW": "中東地區",
    },
    RENA: {
        ar: "أمريكا الشمالية",
        cs: "Severní Amerika",
        da: "Nordamerika",
        de: "Nordamerika",
        el: "Βόρεια Αμερική",
        en: "North America",
        es: "Norteamérica",
        "es-MX": "Norteamérica",
        "es-PR": "Norteamérica",
        fi: "Pohjois-Amerikka",
        fr: "Amérique du nord",
        "fr-CA": "Amérique du Nord ",
        he: "צפון אמריקה",
        hr: "Sjeverna Amerika",
        hu: "Észak-Amerika",
        is: "Norður-Ameríka",
        it: "Nord America",
        ja: "北米",
        ko: "북아메리카",
        nl: "Noord Amerika",
        no: "Nord-Amerika",
        pl: "Ameryka Północna",
        pt: "América do Norte",
        ro: "America de Nord",
        sl: "Severna Amerika",
        sv: "Nordamerika",
        th: "อเมริกาเหนือ",
        tr: "Kuzey Amerika",
        zh: "北美",
        "zh-HK": "北美",
        "zh-TW": "北美地區",
    },
    RESA: {
        ar: "أمريكا الجنوبية",
        cs: "Jižní Amerika",
        da: "Sydamerika",
        de: "Südamerika",
        el: "Νότια Αμερική",
        en: "South America",
        es: "Sudamérica",
        "es-MX": "Sudamérica",
        "es-PR": "Sudamérica",
        fi: "Etelä-Amerikka",
        fr: "Amérique du Sud",
        "fr-CA": "Amérique du Sud",
        he: "דרום אמריקה",
        hr: "Južna Amerika",
        hu: "Dél-Amerika",
        is: "Suður-Ameríka",
        it: "America del Sud",
        ja: "南アメリカ",
        ko: "남아메리카",
        nl: "Zuid-Amerika",
        no: "Sør-Amerika",
        pl: "Ameryka Południowa",
        pt: "América do Sul",
        ro: "America de Sud",
        sl: "Južna Amerika",
        sv: "Sydamerika",
        th: "อเมริกาใต้",
        tr: "Güney Amerika",
        zh: "南美洲",
        "zh-HK": "南美洲",
        "zh-TW": "南美洲",
    },
};
